// extracted by mini-css-extract-plugin
module.exports = {"searchbox":"search-box_searchbox__2otBW","searchbox__input":"search-box_searchbox__input__OnFm5","searchbox__submit":"search-box_searchbox__submit__yO7MC"};